import { Injectable, inject } from '@angular/core';
import { SnackbarService } from 'src/app/services/snackbar.service';

export enum WalletDetailsErrorType {
  LOAD_REGISTRIES = 'LOAD_REGISTRIES',
  DELETE_WALLET = 'DELETE_WALLET',
  TOGGLE_FAVORITE = 'TOGGLE_FAVORITE',
  FIND_WALLET = 'FIND_WALLET',
  EDIT_WALLET = 'EDIT_WALLET',
}

interface ErrorResponse {
  error?: {
    errors?: Array<{ message?: string }>;
    message?: string;
  };
  message?: string;
}

@Injectable({ providedIn: 'any' })
export class WalletDetailsErrorHandlerService {
  private readonly snackbarService = inject(SnackbarService);

  private readonly defaultMessages: Record<WalletDetailsErrorType, string> = {
    [WalletDetailsErrorType.LOAD_REGISTRIES]: $localize`:@@error_load_tracking_registries:Error al cargar documentos de la cartera`,
    [WalletDetailsErrorType.DELETE_WALLET]: $localize`:@@ErrorTryingToExclude:Error al intentar eliminar`,
    [WalletDetailsErrorType.TOGGLE_FAVORITE]: $localize`:@@error_toggle_favorite:Error al actualizar favorito`,
    [WalletDetailsErrorType.FIND_WALLET]: $localize`:@@error_find_wallet:Error al buscar cartera`,
    [WalletDetailsErrorType.EDIT_WALLET]: $localize`:@@error_edit_wallet:Error al editar cartera`,
  };

  handle(error: unknown, type: WalletDetailsErrorType): void {
    console.error(`[WalletDetails] ${type}:`, error);

    const errorMessage = this.extractErrorMessage(error as ErrorResponse, type);
    this.snackbarService.error(errorMessage);
  }

  private extractErrorMessage(error: ErrorResponse, type: WalletDetailsErrorType): string {
    const responseErrorMessage = error?.error?.errors?.[0]?.message ?? error?.error?.message;

    return responseErrorMessage ?? this.defaultMessages[type];
  }
}
